import { render, staticRenderFns } from "./assnew.vue?vue&type=template&id=57573a52&"
import script from "./assnew.vue?vue&type=script&lang=js&"
export * from "./assnew.vue?vue&type=script&lang=js&"
import style0 from "./assnew.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports